import React from 'react';
import { Link } from 'react-router-dom';
import headerLogo from '../../../../img/top_logo.svg';
import { useSelector } from '../../../Redux/store';
const Header = React.memo(() => {
    const mobileApplicationStore = useSelector(state => state.mobileApplication);
    return (React.createElement(React.Fragment, null, mobileApplicationStore ?
        React.createElement(React.Fragment, null)
        :
            React.createElement("header", { className: "bg-haikan-red md:h-40 -md:h-32" },
                React.createElement(Link, { to: "/tool/top", className: "flex justify-center items-center w-full h-full" },
                    React.createElement("div", { className: "w-3/5 md:w-4/9 lg:w-1/3 xl:w-1/4" },
                        React.createElement("img", { className: "", src: headerLogo }))))));
});
export default Header;
